import React, { useCallback, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { DialerSip } from "@mui/icons-material"
import _ from "ansuko"
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography } from "@mui/material"
import UseApiManager from "../../../../manager/api"

const styles = {
    content: {
        error: {
            fontSize: '12px',
            color: 'red',
        },
        box: {
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            width: "350px",
        },
        text: {
            '& .MuiInputLabel-formControl': {
                marginLeft: "1rem",
            }
        }
    },
    loading: {
        box: {
            position: 'absolute',
            inset: '0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#eeeeee9e',
            zIndex: '1',
        },
    }
}

const UserListAddUserDialog = ({open, areas, emails, onCancel, onUpdated }) => {
    
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [error, setError] = useState("")
    const [password, setPassword] = useState("")
    const [rePassword, setRePassword] = useState("")
    const { Post } = UseApiManager()
    const [area, setArea] = useState("")
    const [loading, setLoading] = useState(false)
    const disableSubmit = useMemo(() => {
        if (_.isEmpty(name)) { return true }
        if (_.isEmpty(email)) { return true }
        if (_.isEmpty(password)) { return true }
        if (password !== rePassword) { return true }
        return false
    }, [name, email, password, rePassword])

    const onAdd = useCallback(() => {
        setLoading(true)
        Post("user", {
            name, 
            email,
            password,
            area
        })
            .then(onUpdated)
            .catch(e => {
                setError("更新失敗 " + e)
            })
            .finally(() => setLoading(false))
    }, [
        name, email, password, rePassword, area
    ])

    return (
        <Dialog open={open} style={{zIndex: 10000}}>
            <DialogTitle>ユーザ追加</DialogTitle>
            <DialogContent style={styles.content.box}>
                {error && (<Typography style={styles.content.error}>{error}</Typography>)}
                <TextField required={true} sx={styles.content.text} variant="standard" label="ユーザ名" value={name} onChange={e => setName(e.target.value)} />
                <TextField required={true} sx={styles.content.text} variant="standard" type="email" label="メールアドレス" value={email} onChange={e => setEmail(e.target.value)} />
                <TextField required={true} sx={styles.content.text} variant="standard" type="password" label="パスワード" value={password} onChange={e => setPassword(e.target.value)} />
                <TextField required={true} sx={styles.content.text} variant="standard" type="password" label="再入力" value={rePassword} onChange={e => setRePassword(e.target.value)} />
                <FormControl>
                    <InputLabel>エリア</InputLabel>
                    <Select
                        variant="standard"
                        value={area}
                        style={{ marginTop: "16px" }}
                        onChange={e => setArea(e.target.value)}
                        MenuProps={{
                            style: { zIndex: 10001 }
                        }}
                    >
                        <MenuItem value="" style={{color: "gray"}}>未選択</MenuItem>
                        {areas?.map((v, i) => <MenuItem keY={`area_${i}`} value={v}>{v}</MenuItem>)}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>キャンセル</Button>
                <Button disabled={disableSubmit} onClick={onAdd}>ユーザ追加</Button>
            </DialogActions>
            {loading && (
                <Box style={styles.loading.box}>
                    <CircularProgress style={{color: "#333"}} />
                </Box>
            )}
        </Dialog>
    )

}

UserListAddUserDialog.propTypes = {
    open: PropTypes.bool,
    emails: PropTypes.array,
    areas: PropTypes.array,
    onCancel: PropTypes.func,
    onUpdated: PropTypes.func,
}

export default UserListAddUserDialog